import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import NavigationMenu from './NavigationMenu';
import styles from './Settings.module.css';
import baseStyles from './Home.module.css'

function Settings() {
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status
    var sideNavSize = 300;
    const [username, setUsername] = useState('');

    useEffect(() => {
      function handleResize() {
        setIsCollapsed(window.innerWidth < (768 + sideNavSize));
      }
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
      }, []);

    useEffect(() => {
        const fetchSubscriptionStatus = async () => {
          try {
            const link = 'https://super-stream.co/api/isSubscribed/' + localStorage.getItem("_id");
    
            const responseTest = await axios.get(link, {
              // Add any necessary headers or authentication tokens
            });
    
            // const response = await fetch(link, {
            //   method: 'GET',
            //   // Add any necessary headers or authentication tokens
            // });
    
            if (responseTest.status === 200) {
              setIsSubscribed(responseTest.data.data.isSubscribed);
              setUsername(responseTest.data.data.username); 
            } else {
              // Handle error responses from the server
            }
          } catch (error) {
            // Handle network or fetch-related errors
          }
        };
    
        fetchSubscriptionStatus();
      }, []);

    
    return (
        <div className="container-fluid">
          <div className="row">
          <div className="col">
            <div className="row">
                <div className={`col-2 nonScrollable ${isCollapsed ? `hideSidebar` : `showSidebar`}`}  style={{paddingRight: 0, paddingLeft: 0, width: sideNavSize + 'px'}}>
                    <NavigationMenu />
                </div>
                <div className={` col scrollable ${isCollapsed ? 'col-12' : ''}`} style={{ order: 1}}>
                    <div className="scrollableContent" >
                        <div className="App content-centered">  
                            <div className="row">
                                <div className="col-md-12 d-flex justify-content-center">
                                    <img style={{width: '200px'}}src="images/superbolt.png"></img>
                                </div>
                            </div>

                            

                            {isSubscribed ? (
                            <div className={styles.contained}>
                              <div className="row">
                                  <div className="col-md-12">
                                      <h2 style={{textAlign: 'center'}}>Manage Subscription</h2>
                                  </div>
                              </div> 

                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4 d-flex justify-content-center flex-column">
                                        <div className="row">
                                          <div className="col-md-12">
                                            <p>SUPERSTREAM Subscription is currently active!</p>
                                          </div>
                                        </div> 

                                        <div className="row">
                                          <div className="col-md-12 d-flex justify-content-center ">
                                            <form action="/create-portal-session" method="POST">
                                              <input type="hidden" name="id" value={localStorage.getItem("_id")} />
                                              <button id="checkout-and-portal-button" type="submit">
                                                Manage your subscription
                                              </button>
                                            </form>
                                          </div>
                                        </div> 
                                        <div className="col-md-4"></div>
                                    </div>
                              </div>

                                    </div>
                                      ) :
                                      (
                                        <div className={styles.contained} style={{background: '#fecb00', border: '3px solid black', padding: '10px'}}>
                                        <div className={`row `}> {/* this is to make a grid system within the app window */}
                                          <div className='col-md-12'>
                                          <div className={`row `}>
                                            <div className={`col-md-12 d-flex justify-content-center `}>
                                              <h2>
                                                Are you ready to <span className={baseStyles.logoText} style={{color: 'white', fontSize: 'inherit'}}>Supercharge</span> your stream?
                                              </h2>
                                            </div>
                                          </div>

                                            <div className={`row `}>
                                              <div className={`col-md-12 `}>
                                                <p>
                                                  Unlock full access to <span className={baseStyles.logoText} style={{fontSize: 'inherit', color: 'black', textShadow: '0px 0px 0 black'}}>Superstream</span> with a subscription!
                                                </p>
                                              </div>
                                            </div>

                                            <div className={`row `}>
                                              <div className={`col-md-12 `}>
                                                <p>
                                                  Basic tier ➡️ 👑 <span style={{fontWeight: 'bold'}}>Premium tier </span>👑
                                                </p>
                                              </div>
                                            </div>

                                            <div className={`row `}>
                                              <div className={`col-md-12 `}>
                                                <p>
                                                  Ads between SHOWCASE TikToks ➡️ ✨ <span style={{fontWeight: 'bold'}}>Ad-free experience </span>✨
                                                </p>
                                              </div>
                                            </div>

                                            <div className={`row `}>
                                              <div className={`col-md-12 `}>
                                                <p>
                                                  Max. 3 SHOWCASE TikToks ➡️ ⚡<span style={{fontWeight: 'bold'}}>Up to 20 SHOWCASE TikToks </span>⚡
                                                </p>
                                              </div>
                                            </div>

                                            <div className={`row `}>
                                              <div className={`col-md-12 `}>
                                                <p>
                                                  Limited access to new apps ➡️ 🌟<span style={{fontWeight: 'bold'}}>Complete access to new apps </span>🌟
                                                </p>
                                              </div>
                                            </div>

                                            <div className={`row `}>
                                              <div className={`col-md-12 justify-content-center d-flex`}>
                                                <form action="/create-checkout-session" method="POST">
                                                  <input type="hidden" name="id" value={localStorage.getItem("_id")} />
                                                  <input type="hidden" name="lookup_key" value="tier_1" />
                                                  <button id="checkout-and-portal-button" type="submit">
                                                    Subscribe
                                                  </button>
                                                </form>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                </div>
                                        // <div className="col-md-4 justify-content-center">
                                        //   <div className="row">
                                        //       <div className="col-md-12">
                                        //         <p>Subscribe to SUPERSTREAM and gain access to a suite of tools that boost engagement and viewership!</p>
                                        //       </div>
                                        //   </div> 
                                          
                                        //   <div className="row">
                                        //     <div className="col-md-12 d-flex justify-content-center">
                                        //       <form action="/create-checkout-session" method="POST">
                                        //         <input type="hidden" name="id" value={localStorage.getItem("_id")} />
                                        //         <input type="hidden" name="lookup_key" value="tier_1" />
                                        //         <button id="checkout-and-portal-button" type="submit">
                                        //           Subscribe
                                        //         </button>
                                        //       </form>
                                        //     </div>
                                        //   </div>
                                        // </div>
                                      )}

<div className={styles.contained}>
                              <div className="row">
                                  <div className="col-md-12">
                                      <div className="row">
                                          <div className="col-md-12">
                                            <h2 style={{textAlign: 'center'}}>Account Settings</h2>
                                          </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-12">
                                          <p>Information relating to this account:</p>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-12">
                                          <p>Email: {username}</p>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-12">
                                          {localStorage.getItem("isSubscribed") === "true" ? (
                                            <p>Subscription status: Active</p>
                                            ) :
                                            (
                                              <p>Subscription status: Inactive</p>
                                            )}
                                        </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                                    

                              <div className={styles.contained}>
                              <div className="row">
                                  <div className="col-md-12">
                                      <div className="row">
                                          <div className="col-md-12">
                                            <h2 style={{textAlign: 'center'}}>Contact Us</h2>
                                          </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-12">
                                          <p>Have you found a bug or an issue with one of our products? Let us know at:<br></br>
                                          support@superstream.co</p>
                                        </div>
                                      </div>
                                      <div className={`row justify-content-center`}>
                                          <div className={`col-md-12 d-flex justify-content-center`}>
                                            <div className={`row justify-content-center`}>
                                              <div className={`col-md-3 d-flex justify-content-center`}>
                                                <a href='https://twitter.com/superstreamco' target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/twitterwhite.png"></img></a>
                                              </div>

                                              <div className={`col-md-3 d-flex justify-content-center`}>
                                                <a href="https://instagram.com/superstream" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/instawhite.png"></img></a>
                                              </div>

                                              <div className={`col-md-3 d-flex justify-content-center`}>
                                                <a href="https://tiktok.com/superstream" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/tiktokwhite.png"></img></a>
                                              </div>

                                              <div className={`col-md-3 d-flex justify-content-center`}>
                                                <a href="https://youtube.com/superstream" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/youtubewhite.png"></img></a>
                                              </div>
                                            </div>
                                            
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </div>

                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
     

        
    );
}


export default Settings;
